<template>
  <div>
    <Loading :isProcessing="isProcessing"></Loading>
    <ul class="l-docList">
      <li class="l-docList__item" v-for="(item, index) in fileList" :key=index>
        <div v-if="item.isDirectory">
          <a @click="clickFolderName(item.pathArrayForDisplay)">
            <div class="icon"><img src="@/assets/img/common/icon-folder.svg" width="20px" alt=""></div>
            <div class="text">{{ item.name }}</div>
          </a>
        </div>
        <div v-else>
          <template v-if="!item.isPdf">
            <a @click="download(item.path, item.name)">
              <div class="icon"><img src="@/assets/img/common/icon-file.svg" width="16px" alt=""></div>
              <div class="text">{{ item.name }}<span class="size">（{{ item.fileSize }}Mb）</span></div>
              <div class="thum" @click.prevent.stop="preview(item.previewFile, item.name)" v-if="item.previewFile">
                <img :src="item.previewFile" class="js-modal-open" alt="" style="max-width: 100%; height: auto; width /***/:auto;">
              </div>
            </a>
          </template>
          <template v-else>
            <a :href="item.fileUrl" target="_blank">
              <div class="icon"><img src="@/assets/img/common/icon-file.svg" width="16px" alt=""></div>
              <div class="text">{{ item.name }}<span class="size">（{{ item.fileSize }}Mb）</span></div>
              <div class="thum" @click.prevent.stop="preview(item.previewFile, item.name)" v-if="item.previewFile">
                <img :src="item.previewFile" class="js-modal-open" alt="" style="max-width: 100%; height: auto; width /***/:auto;">
              </div>
            </a>
          </template>
        </div>
      </li>
    </ul>
    <pagination
      :pageInfo="pageInfo"
      @change-page="emitChangePage">
    </pagination>
  </div>
</template>

<script>
import Vue from 'vue';
import Loading from '@/components/parts/common/Loading.vue';
import Pagination from '@/components/parts/common/Pagination.vue';
import PdfViewer from '@/components/parts/common/PdfViewer.vue';
import { saveAs } from "file-saver";

export default {
  components: {
    Loading,
    Pagination,
  },
  computed: {
    path() {
      return this.$store.getters['doc/getPath'];
    },
    searchKeyword() {
      return this.$store.getters['doc/getSearchKeyword'];
    },
    isSearchMode() {
      return this.$store.getters['doc/getIsSearchMode'];
    }
  },
  watch: {
    path() {
      if (!this.path) return;
      this.getDocList(this.path, 1);
    },
  },
  data() {
    return {
      isProcessing: false,
      pageInfo: {},
      fileList: [],
    }
  },
  created: function() {
  },
  methods: {
    emitChangePage(page) {
      if (!this.isSearchMode) {
        this.getDocList(this.path, page)
      } else {
        this.searchDocFileList(this.searchKeyword, page);
      }
    },
    clickFolderName(pathArrayForDisplay) {
      this.$store.dispatch('doc/setPathArrayForDisplay', pathArrayForDisplay);
      let path = pathArrayForDisplay.join('/');
      this.getDocList(path, 1);
    },
    async getDocList(path, page) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/document/getDocFileList', {
        page: page,
        path: path
      });
      if (res) {
        this.fileList = res.data.fileList.data;
        this.pageInfo = {
          currentPage: res.data.fileList.current_page,
          lastPage: res.data.fileList.last_page,
          total: res.data.fileList.total,
          from: res.data.fileList.from,
          to: res.data.fileList.to,
        };
        this.$store.dispatch('doc/setIsSearchMode', false);
      }
      this.isProcessing = false;
    },
    async searchDocFileList(keyword, page) {
      this.isProcessing = true;
      let res = await this.$axios.post('/ld/api/document/searchDocFileList', {
        keyword: keyword,
        page: page,
      });
      if (res) {
        this.fileList = res.data.fileList.data;
        this.pageInfo = {
          currentPage: res.data.fileList.current_page,
          lastPage: res.data.fileList.last_page,
          total: res.data.fileList.total,
          from: res.data.fileList.from,
          to: res.data.fileList.to,
        };
        this.$emit('emit-set-search-result-count', {
          searchResultCount: this.pageInfo.total
        });
      }
      this.isProcessing = false;
    },
    async download(path, fileName) {
      await saveAs('/ld/api/document/downloadDocumentFile?path=' + encodeURI(path) + '&fileName=' + encodeURI(fileName));
    },
    async preview(previewFile, fileName) {
/*
      let res = await this.$axios.post('/ld/api/document/generatePreviewFile', {
        path: path,
        fileName: fileName,
      });
*/
      var pdfViewer = Vue.extend(PdfViewer)
      var instance = new pdfViewer({
        propsData: {
          src: previewFile,
          isPdf: false,
          fileName: fileName,
        }
      });
      instance.$mount();
    }
  }
}

</script>
